import axios from "axios";
import store from "@/state/store";

const globalRequestCounter = { value: 0 };

const syncGlobalLoader = () => {
  const isLoading = globalRequestCounter.value > 0;
  if (store && store.dispatch) {
    store.dispatch("layout/changeLoaderValue", { loader: isLoading });
  }
};

export const API = axios.create({
  //baseURL: `http://localhost:9811/`,
  baseURL: `https://api.ircng.org`,
  timeout: 420000, 
});

API.interceptors.request.use(
  (config) => {
    config.timeout = config.timeout || 420000;
    globalRequestCounter.value += 1;
    syncGlobalLoader();
    return config;
  },
  (error) => {
    globalRequestCounter.value = Math.max(globalRequestCounter.value - 1, 0);
    syncGlobalLoader();
    return Promise.reject(error);
  }
);

API.interceptors.response.use(
  (response) => {
    globalRequestCounter.value = Math.max(globalRequestCounter.value - 1, 0);
    syncGlobalLoader();
    return response;
  },
  (error) => {
    globalRequestCounter.value = Math.max(globalRequestCounter.value - 1, 0);
    syncGlobalLoader();
    return Promise.reject(error);
  }
);

export function SET_TOKEN(token) {
  API.defaults.headers.common["x-auth-token"] = token;
  localStorage.setItem("token", token);
}

export const AUTH_HEADER = () => {
  let token = localStorage.getItem("token");
  if (token) {
    return { "x-auth-token": token };
  }
};

export const ROUTES = {
  department: `departments`,
  grade: `grades`,
  jobRole: `job-roles`,
  paymentDefinition: `payment-definitions`,
  state: `states`,
  minimumTaxRate: `minimum-tax-rate`,
  taxRate: `tax-rates`,
  user: `users`,
  location: `locations`,
  countries: `countries`,
  publicHolidays: `public-holidays`,
  performanceImprovement: `performance-improvement`,
  bank: `banks`,
  employee: `employees`,
  leaveType: `leave-types`,
  leaveApplication: `leave-application`,
  pensionProvider: `pension-providers`,
  hmo: `hmos`,
  qualification: `qualifications`,
  subsidiary: `subsidiaries`,
  supervisorAssignment: `supervisor-assignment`,
  timesheet: `time-sheet`,
  timeAllocation: `time-allocation`,
  payrollMonthYear: `payroll-month-year`,
  salaryGrade: `salary-grade`,
  donor: `donor`,
  locationAllowance: `location-allowance`,
  rating: `rating`,
  goalSetting: `goal-setting`,
  endOfYear: `end-year-assessment`,
  grantChart: `grant-chart`,
  endYearRating: "end-year-rating",
  selfAssessment: "self-assessment",
  travelApplication: `travel-applications`,
  variationalPayment: `variational-payment`,
  salaryStructure: `salary-structure`,
  authorization: `application-authorization`,
  authorizationRole: `authorization-roles`,
  appAuthorization: `application-authorization`,
  timeSheetPenalty: `time-sheet-penalty`,
  leaveAccrual: `leave-accrual`,
  salary: `salary`,
  goalSettingYear: `goal-setting-year`,
  localGovernment: `local-government`,
  education: `education`,
  workExperience: `work-experience`,
  announcement: `announcements`,
  queries: `queries`,
  queryReply: `query-reply`,
  hrFocalPoint: `hr-focal-point`,
  leaveDoc: `leavedoc`,
  notifications: `notifications`,
  endYearResponse: `end-year-response`,
  payrollJournal: "payroll-journal",
  employeeCategory: "employee-categories",
  masterList: "master-list",
  countryCodes: "country-codes",
  reliefType: "relief-types",
  taxRelief: "tax-reliefs",
};
